<template>
  <AccordBlock>
    <template slot="header">
      <div class="fragment"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fba_dimensions'])"></div>
        {{ $t('fba_dimensions.localization_value.value') }}
        <!--        Dimensions-->
      </div>
    </template>

    <template slot="body">
      <div class="fragment pt-4">
        <DimensionsBlock
            :FBA="FBA"
        />
      </div>
    </template>
  </AccordBlock>
</template>

<script>
  import AccordBlock from "../../../../../../../coreComponents/AccordBlock/AccordBlock";
  import {mixinDetictingMobile} from "../../../../../../../../mixins/mobileFunctions";
  import DimensionsBlock from "../../../../components/chunks/DimensionsBlock/DimensionsBlock";

  export default {
    name: "Dimensions",
    components: {
      AccordBlock,
      DimensionsBlock,
    },

    props: {
      FBA: Object
    },

    mixins: [mixinDetictingMobile],

    data() {
      return {
      }
    },
  }
</script>

<style scoped lang="scss">

</style>
